import { useLang } from "../context/LanguageContext";

const ITEMS = {
  it: [
    "Cucina Piemontese",
    "Vetrina delle Carni",
    "Piazza Castello 41",
    "Vini del Monferrato",
    "Tradizione e Innovazione",
  ],
  en: [
    "Piedmontese Cuisine",
    "The Meat Display",
    "Piazza Castello 41",
    "Monferrato Wines",
    "Tradition and Innovation",
  ],
};

export default function Marquee() {
  const { lang } = useLang();
  const row = [...ITEMS[lang], ...ITEMS[lang]];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[rgba(201,162,101,0.18)] bg-[#171512] py-5 overflow-hidden"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-serif-display italic text-xl sm:text-2xl text-[#B0A89C] px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-[#C9A265] text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
